import {getCaption} from "@/util/Helpers";
import {
    hmAnalhpshsValidator,
    hmApoleiasValidator,
    hmYpovolhsDpkApo,
    hmYpovolhsDpkEos,
    hmYpovolhsKatalogEos,
    initialDPKApo,
    initialDPKEos,
    intYearOnlyPastValidation,
    intYearValidation,
    yearOnlyPastValidation,
    yearValidation,
    hmDhloshsSyzygoyApoValid,
    hmDhloshsSyzygoyEosValid,
    hmAnalhpshsEosValid
} from "@/util/Validators";

const ERROR_MESSAGE_ENUM = {
    YEAR_VALIDATION: 'To Έτος δεν μπορεί να είναι μεταγενέστερο του έτους που αφορά η ΔΠΚ.',
    YEAR_ONLY_PAST_VALIDATION: 'Η ημ/νία πρέπει να είναι μεταγενέστερη του έτους 1900.',

}


export function validationHandler(column) {
    const errors = []
    if (!column.$dirty) return errors
    for (const property in column.$params) {
        if (property === 'maxLength') {
            !column.maxLength && errors.push('Το μέγεθος του πεδίου δεν μπορεί να είναι μεγαλύτερο από ' + column.$params.maxLength.max + ' χαρακτήρες.')
            // !column.maxLength && errors.push(store.getters.locales['validationMessages']['maxLength'],[column.$params.maxLength.max])
        } else if (property === 'minLength') {
            !column.minLength && errors.push('Το μέγεθος του πεδίου δεν μπορεί να είναι λιγότερους από ' + column.$params.minLength.min + ' χαρακτήρες.')
            // !column.minLength && errors.push(store.getters.locales['validationMessages']['minLength'].replace('{0}',column.$params.minLength.min),[column.$params.minLength.min])
        } else if (property === 'maxValue') {
            !column.maxValue && errors.push('Η τιμή του πεδίου δεν μπορεί να είναι μεγαλύτερη από ' + column.$params.maxValue.max)
            // (column.$model !== undefined && column.$model !== null && column.$model.size > column.$params.maxValue.max)
            // && errors.push(store.getters.locales['validationMessages']['maxValue'].replace('{0}',column.$params.maxValue.max),[column.$params.maxValue.max])
        } else if (property === 'minValue') {
            !column.minValue && errors.push('Η τιμή του πεδίου δεν μπορεί να είναι μικρότερη από ' + column.$params.minValue.min)
            // (column.$model !== undefined && column.$model !== null && column.$model.size > column.$params.maxValue.max)
            // && errors.push(store.getters.locales['validationMessages']['maxValue'].replace('{0}',column.$params.maxValue.max),[column.$params.maxValue.max])
        } else if (property === 'numeric') {
            !column.numeric && errors.push('Το πεδίο πρέπει να είναι αριθμός')
        } else if (property === 'required') {
            // !column.required && errors.push(store.getters.locales['validationMessages']['required'])
            !column.required && errors.push('Υποχρεωτικό Πεδίο')
        } else if (property === 'amkaValidator') {
            // !column.required && errors.push(store.getters.locales['validationMessages']['required'])
            !column.amkaValidator && errors.push('Λάθος ΑΜΚΑ')
        } else if (property === 'hmYpovolhsKatalogEos') {
            // !column.required && errors.push(store.getters.locales['validationMessages']['required'])
            !column.hmYpovolhsKatalogEos && errors.push('Πρέπει να είναι μεγαλύτερη από την "Ημ/νία Υποβολής Καταλόγων από"')
        } else if (property === 'hmYpovolhsKatalogApo') {
            // !column.required && errors.push(store.getters.locales['validationMessages']['required'])
            !column.hmYpovolhsKatalogApo && errors.push('Πρέπει να είναι μικρότερη από την "Ημ/νία Υποβολής Καταλόγων έως"')
        } else if (property === 'hmYpovolhsDpkEos') {
            // !column.required && errors.push(store.getters.locales['validationMessages']['required'])
            !column.hmYpovolhsDpkEos && errors.push('Πρέπει να είναι μεγαλύτερη από την "Ημ/νία Υποβολής ΔΠΚ από"')
        } else if (property === 'hmYpovolhsDpkApo') {
            // !column.required && errors.push(store.getters.locales['validationMessages']['required'])
            !column.hmYpovolhsDpkApo && errors.push('Πρέπει να είναι μικρότερη από την "Ημ/νία Υποβολής ΔΠΚ έως"')
        } else if (property === 'initialDPKEos') {
            // !column.required && errors.push(store.getters.locales['validationMessages']['required'])
            !column.initialDPKEos && errors.push('Πρέπει να είναι μεγαλύτερη από την "Ημ/νία Υποβολής Ανάληψης από"')
        } else if (property === 'initialDPKApo') {
            // !column.required && errors.push(store.getters.locales['validationMessages']['required'])
            !column.initialDPKApo && errors.push('Πρέπει να είναι μικρότερη από την "Ημ/νία Υποβολής Ανάληψης έως"')
        }else if (property === 'hmDhloshsSyzygoyEos') {
            // !column.required && errors.push(store.getters.locales['validationMessages']['required'])
            !column.hmDhloshsSyzygoyEos && errors.push('Πρέπει να είναι μεγαλύτερη από την "Ημ/νία Γνωστοποίησης Στοιχείων Συζύγου από"')
        }else if (property === 'hmAnalhpshsEos') {
            // !column.required && errors.push(store.getters.locales['validationMessages']['required'])
            !column.hmAnalhpshsEos && errors.push('Πρέπει να είναι μεγαλύτερη από την "Ημ/νία Υποβολής Ανάληψης από"')
        }  else if (property === 'hmDhloshsSyzygoApo') {
            // !column.required && errors.push(store.getters.locales['validationMessages']['required'])
            !column.hmDhloshsSyzygoApo && errors.push('Πρέπει να είναι μικρότερη από την "Ημ/νία Γνωστοποίησης Στοιχείων Συζύγου έως"')
        } else if (property === 'dateValidator') {
            // !column.required && errors.push(store.getters.locales['validationMessages']['required'])
            !column.dateValidator && errors.push('Η Ημ/νία πρέπει είναι της μορφής ΗΗ/ΜΜ/ΧΧΧΧ όπου {ΗΗ = αριθμός ημέρας}, {ΜΜ = αριθμός μήνα} και {ΧΧΧΧ = αριθμός έτους}')
        } else if (property === 'datePatternValidator') {
            // !column.required && errors.push(store.getters.locales['validationMessages']['required'])
            !column.datePatternValidator && errors.push('Η Ημ/νία πρέπει είναι της μορφής ΗΗ/ΜΜ/ΧΧΧΧ όπου {ΗΗ = αριθμός ημέρας}, {ΜΜ = αριθμός μήνα} και {ΧΧΧΧ = αριθμός έτους}')
        } else if (property === 'validCalc') {
            // !column.required && errors.push(store.getters.locales['validationMessages']['required'])
            !column.validCalc && errors.push('Το σύνολο δεν είναι το ίδιο')
        } else if (property === 'emailValidator') {
            // !column.required && errors.push(store.getters.locales['validationMessages']['required'])
            !column.emailValidator && errors.push(getCaption('VALIDATION_EMAIL_INVALID'))
        } else if (property === 'namesValidator') {
            // !column.required && errors.push(store.getters.locales['validationMessages']['required'])
            !column.namesValidator && errors.push(getCaption('VALIDATION_NAMES_INVALID'))
        } else if (property === 'noFutureDateValidator') {
            // !column.required && errors.push(store.getters.locales['validationMessages']['required'])
            !column.noFutureDateValidator && errors.push(getCaption('VALIDATION_YEAR_FUTURE_INVALID'))
        } else if (property === 'hmApoleiasValidator') {
            // !column.required && errors.push(store.getters.locales['validationMessages']['required'])
            !column.hmApoleiasValidator && errors.push('Η ημ/νία απώλειας ιδιότητας πρέπει να είναι μεταγενέστερη της ημ/νίας απόκτησης ιδιότητας και μικρότερη από το τέλος του μήνα που αφορά ο μηνιαίος κατάλογος.')
        } else if (property === 'hmAnalhpshsValidator') {
            // !column.required && errors.push(store.getters.locales['validationMessages']['required'])
            !column.hmAnalhpshsValidator && errors.push('Δεν επιτρέπεται η καταχώρηση ιδιότητας με ημερομηνία ανάληψης εκτός των ορίων του προηγούμενου μήνα.')
        } else if (property === 'yearValidation') {
            // !column.required && errors.push(store.getters.locales['validationMessages']['required'])
            !column.yearValidation && errors.push(ERROR_MESSAGE_ENUM.YEAR_VALIDATION)
        } else if (property === 'intYearValidation') {
            // !column.required && errors.push(store.getters.locales['validationMessages']['required'])
            !column.intYearValidation && errors.push(ERROR_MESSAGE_ENUM.YEAR_VALIDATION)
        } else if (property === 'intYearOnlyPastValidation') {
            !column.intYearOnlyPastValidation && errors.push(ERROR_MESSAGE_ENUM.YEAR_ONLY_PAST_VALIDATION)
        } else if (property === 'yearOnlyPastValidation') {
            !column.yearOnlyPastValidation && errors.push(ERROR_MESSAGE_ENUM.YEAR_ONLY_PAST_VALIDATION)
        }else if (property === 'afmValidator') {
            // !column.required && errors.push(store.getters.locales['validationMessages']['required'])
            !column.afmValidator && errors.push('Λάθος ΑΦΜ')
        }
    }
    return errors.join(' , ').toString()
}
